import { render, staticRenderFns } from "./InvesmentPerformanceDisclosureCopy.vue?vue&type=template&id=2a9ea434"
import script from "./InvesmentPerformanceDisclosureCopy.vue?vue&type=script&lang=ts"
export * from "./InvesmentPerformanceDisclosureCopy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports